import { CatIconCircleFull } from '@blocks-react/components/Icons/CircleFull';
import { CatIconSuccessFilled } from '@blocks-react/components/Icons/SuccessFilled';
import { CatIconWarningDiamondFilled } from '@blocks-react/components/Icons/WarningDiamondFilled';
import { CatIconWarningTriangleFilled } from '@blocks-react/components/Icons/WarningTriangleFilled';

type StatusIndicatorIconProps = {
  variant?: 'active' | 'error' | 'warning';
};

const StatusIndicatorIcon = ({ variant }: StatusIndicatorIconProps) => {
  if (variant === 'active') {
    return <CatIconSuccessFilled slot="before" />;
  } else if (variant === 'error') {
    return <CatIconWarningDiamondFilled slot="before" />;
  } else if (variant === 'warning') {
    return <CatIconWarningTriangleFilled slot="before" />;
  }
  return <CatIconCircleFull slot="before" />;
};

export default StatusIndicatorIcon;
